import * as React from "react";
import confetti from "canvas-confetti";
import { getConfettis } from "@util/spring-animations.util";
interface IConfettiCanvasProps {
  className: string;
}
export const ConfettiCanvas = ({ className }: IConfettiCanvasProps) => {
  const confettiCanvasRef = React.useRef<HTMLCanvasElement>(null);
  const confettiRef = React.useRef<confetti.CreateTypes | null>(null);

  React.useEffect(() => {
    if (confettiCanvasRef.current) {
      if (!confettiRef.current) {
        confettiRef.current = confetti.create(confettiCanvasRef.current, {
          useWorker: false, // Cannot use web workers with multiple canvases.
          // Confetti would only pop on a single scheduling-link-card otherwise.
          resize: true,
        });
      }
      // Put into an array, so we can add lots of random confettis
      const confettis = getConfettis();
      void confettiRef.current(confettis[Math.floor(Math.random() * confettis.length)]);
    }
  }, []);

  return <canvas ref={confettiCanvasRef} className={className} />;
};
